<template>
  <div>
    <base-page-heading title="Regional Manager KPI Report" />
    <div class="content">
      <regional-manager-list-filter
        :columns="columns"
        :initial-filters="filters"
        @filters-applied="applyFilters"
      />
      <regional-manager-table
        :filters="filters"
        :columns="columns"
        :sort-by="sortBy"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
      />
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import listMixin from '@/mixins/listMixin';
import RegionalManagerListFilter from '@/components/admin/reports/users/RegionalManagerListFilter.vue';
import RegionalManagerTable from '@/components/admin/reports/users/RegionalManagerTable.vue';
import { WORK_ORDER_REGIONAL_MANAGER_REPORT_TABLE_NAME } from '@/constants/reports';

export default {
  name: 'RegionalManagersReport',
  components: {
    RegionalManagerTable,
    RegionalManagerListFilter,
  },
  mixins: [listMixin],
  props: {
    manager_id: String,
    client_id: String,
    service_id: String,
    state: String,
    start_date: String,
    end_date: String,
    sortBy: {
      type: String,
      default: 'revenue_cents',
    },
  },
  data() {
    return {
      tableName: WORK_ORDER_REGIONAL_MANAGER_REPORT_TABLE_NAME,
      filters: {
        manager_id: this.manager_id,
        client_id: this.client_id,
        service_id: this.service_id,
        state: this.state,
        start_date: this.start_date || this.$options.filters.dateFormat(DateTime.now().minus({ month: 6 }).startOf('month').toISODate()),
        end_date: this.end_date || this.$options.filters.dateFormat(DateTime.now().toISODate()),
      },
    };
  },
};
</script>
